import React from 'react';
import { CircularProgress, Menu, MenuItem } from '@mui/material';
import { LinkOff, Sync } from '@mui/icons-material';
import { TodoIntegrationType } from '@demind-inc/core';
import { useTranslation } from 'react-i18next';

import './TodoListMoreDropdown.scss';
import { TodoListMoreDropdownOption } from './types';

interface TodoListMoreDropdownProps {
  anchorEl: HTMLElement | null;
  sourceTitle: string;
  todoType?: TodoIntegrationType;
  loadingOption?: TodoListMoreDropdownOption;
  onClickItem: (option: TodoListMoreDropdownOption) => void;
  onClose: () => void;
}

const options: Record<TodoListMoreDropdownOption, { actionKey: string; icon: JSX.Element }> = {
  sync: {
    actionKey: 'task.todoIntegration.reconnect',
    icon: <Sync fontSize="small" />,
  },
  disconnect: {
    actionKey: 'task.todoIntegration.disconnect',
    icon: <LinkOff fontSize="small" />,
  },
};

const TodoListMoreDropdown: React.FC<TodoListMoreDropdownProps> = ({
  anchorEl,
  sourceTitle,
  todoType,
  loadingOption,
  onClickItem,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Menu
      className="todo-list-more-dropdown"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      {Object.entries(options).map(([option, { actionKey, icon }]) => {
        const label =
          option === 'sync' && todoType === 'apple-reminders'
            ? t('task.todoIntegration.refresh')
            : t(actionKey);
        return (
          <MenuItem
            key={option}
            disabled={!!loadingOption}
            onClick={() => onClickItem(option as TodoListMoreDropdownOption)}
            className="todo-list-more-dropdown__option"
          >
            {loadingOption === option ? <CircularProgress size={15} /> : icon}
            <p className="todo-list-more-dropdown__option__title">
              {label} {sourceTitle}
            </p>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default TodoListMoreDropdown;
